export const SITE_RECENT_ACTIONS_CARD_FRENCH_LOCALE = {
  title: "Actions récentes",
  lastCall: "Dernier appel",
  lastHardwareConfiguration: "Dernière configuration matérielle",
  lastSoftwareConfiguration: "Dernière mise à jour logicielle",
};
